import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { TranslationProvider } from './contexts/TranslationContext';
import { AuthProvider } from './contexts/AuthContext';
import { UserDataProvider } from './contexts/UserDataContext';
import { ShopCartProvider } from './contexts/ShopCartContext';
import Navbar from './components/Navbar';
import SiteVisitTracker from './components/SiteVisitTracker';
import PWAInstallBanner from './components/Performance/PWAInstallBanner';
import MobileShell from './mobile/MobileShell';
import AppRoutes from './routing/routes';
import { TodayHistoryPopup } from './routing/lazyPages';
import { isNativeApp } from './utils/platform';
import './styles/animations.css';

function App() {
  const native = isNativeApp();

  return (
    <Router>
      <LanguageProvider>
        <TranslationProvider>
          <AuthProvider>
            <UserDataProvider>
              <ShopCartProvider>
                <div className={native ? 'gadkot-app gadkot-app--native' : 'min-h-screen bg-gray-50'}>
                  <SiteVisitTracker />
                  {!native && <Navbar />}
                  {!native && (
                    <Suspense fallback={null}>
                      <TodayHistoryPopup />
                    </Suspense>
                  )}
                  {!native && <PWAInstallBanner />}
                  {native ? (
                    <MobileShell>
                      <AppRoutes native />
                    </MobileShell>
                  ) : (
                    <AppRoutes native={false} />
                  )}
                </div>
              </ShopCartProvider>
            </UserDataProvider>
          </AuthProvider>
        </TranslationProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
